import { migrateFieldOperatorsConfig } from "../../helpers/migrateFieldOperatorsConfig";

export function setCategories(categories) {
    return {
        type: ACTION_SET_CATEGORIES,
        categories: categories
            .map(cat => ({
                ...cat,
                fields: cat.fields
                    .map(f => ({
                        ...f,
                        operators: migrateFieldOperatorsConfig(f.operators),
                    }))
                    // exclude fields without operators defined
                    .filter(f => f.operators.length),
            }))
            // exclude categories without defined fields
            .filter(cat => cat.fields.length),
    };
}
export const ACTION_SET_CATEGORIES = 'QRY_ACTION_SET_CATEGORIES';
